module.exports = __webpack_public_path__ + "static/research-89b7eaabd637ea5b9ad055073b94d65d.png";